import { render, staticRenderFns } from "./MonthlyBudgetChart.vue?vue&type=template&id=5d874947&scoped=true"
import script from "./MonthlyBudgetChart.vue?vue&type=script&lang=ts"
export * from "./MonthlyBudgetChart.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyBudgetChart.vue?vue&type=style&index=0&id=5d874947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d874947",
  null
  
)

export default component.exports